/**
 * @desc 新增(弃用，前端去除对应功能)
 */
const URL = "/rantion-ucenter";
import http, { updateResponse } from "@/http";
export function request(body: defs.ucenter.OrganizationRequestDto, options?: any) {
  return updateResponse(
    http(URL + `/organization/add`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
